<template>
  <div class="app-wrap">
    <!--start login contant-->
    <div class="app-contant">
      <div class="bg-white">
        <div class="container-fluid p-0">
          <div class="row no-gutters">
            <div class="col-sm-6 col-lg-5 col-xxl-3 align-self-center order-2 order-sm-1">
              <div class="d-flex align-items-center h-100-vh">
                <div class="login p-50">
                  <div class="mb-2">
                    <svg width="589" height="127" viewBox="0 0 589 127" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M120 46.25L60 0L0 46.25L60 92.5L75.0397 80.9069L60.0394 69.3442L90.0394 46.2192L105.04 57.7819L120 46.25ZM89.9804 46.2344L59.9804 23.1094L29.9804 46.2344L59.9804 69.3594L89.9804 46.2344Z" fill="#292A2F"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.28748e-05 80.0937L60 126.344L120 80.0938L60 33.8438L44.9604 45.4368L59.9606 56.9995L29.9606 80.1245L14.9603 68.5618L1.28748e-05 80.0937ZM30.0196 80.1094L60.0196 103.234L90.0196 80.1094L60.0196 56.9844L30.0196 80.1094Z" fill="#42A4D9"/>
                      <path d="M193.944 37.288C193.475 38.2267 192.92 38.888 192.28 39.272C191.683 39.656 190.957 39.848 190.104 39.848C189.251 39.848 188.291 39.528 187.224 38.888C186.157 38.2053 184.899 37.4587 183.448 36.648C181.997 35.8373 180.291 35.112 178.328 34.472C176.408 33.7893 174.125 33.448 171.48 33.448C169.091 33.448 167 33.7467 165.208 34.344C163.459 34.8987 161.965 35.688 160.728 36.712C159.533 37.736 158.637 38.9733 158.04 40.424C157.443 41.832 157.144 43.3893 157.144 45.096C157.144 47.272 157.741 49.0853 158.936 50.536C160.173 51.9867 161.795 53.224 163.8 54.248C165.805 55.272 168.088 56.1893 170.648 57C173.208 57.8107 175.811 58.6853 178.456 59.624C181.144 60.52 183.768 61.5867 186.328 62.824C188.888 64.0187 191.171 65.5547 193.176 67.432C195.181 69.2667 196.781 71.528 197.976 74.216C199.213 76.904 199.832 80.168 199.832 84.008C199.832 88.1893 199.107 92.1147 197.656 95.784C196.248 99.4107 194.157 102.589 191.384 105.32C188.653 108.008 185.304 110.141 181.336 111.72C177.368 113.256 172.824 114.024 167.704 114.024C164.76 114.024 161.859 113.725 159 113.128C156.141 112.573 153.389 111.763 150.744 110.696C148.141 109.629 145.688 108.349 143.384 106.856C141.123 105.363 139.096 103.699 137.304 101.864L142.296 93.608C142.765 93.0107 143.32 92.52 143.96 92.136C144.643 91.7093 145.389 91.496 146.2 91.496C147.267 91.496 148.419 91.944 149.656 92.84C150.893 93.6933 152.344 94.6533 154.008 95.72C155.715 96.7867 157.699 97.768 159.96 98.664C162.264 99.5173 165.016 99.944 168.216 99.944C173.123 99.944 176.92 98.792 179.608 96.488C182.296 94.1413 183.64 90.792 183.64 86.44C183.64 84.008 183.021 82.024 181.784 80.488C180.589 78.952 178.989 77.672 176.984 76.648C174.979 75.5813 172.696 74.6853 170.136 73.96C167.576 73.2347 164.973 72.4453 162.328 71.592C159.683 70.7387 157.08 69.7147 154.52 68.52C151.96 67.3253 149.677 65.768 147.672 63.848C145.667 61.928 144.045 59.5387 142.808 56.68C141.613 53.7787 141.016 50.216 141.016 45.992C141.016 42.6213 141.677 39.336 143 36.136C144.365 32.936 146.328 30.0987 148.888 27.624C151.491 25.1493 154.669 23.1653 158.424 21.672C162.179 20.1787 166.467 19.432 171.288 19.432C176.749 19.432 181.784 20.2853 186.392 21.992C191 23.6987 194.925 26.088 198.168 29.16L193.944 37.288ZM295.017 99.112C298.345 99.112 301.31 98.5573 303.913 97.448C306.558 96.3387 308.777 94.7813 310.569 92.776C312.404 90.7707 313.79 88.3387 314.729 85.48C315.71 82.6213 316.201 79.4213 316.201 75.88V20.456H333.417V75.88C333.417 81.384 332.521 86.4827 330.729 91.176C328.98 95.8267 326.441 99.8587 323.113 103.272C319.785 106.643 315.753 109.288 311.017 111.208C306.281 113.085 300.948 114.024 295.017 114.024C289.086 114.024 283.753 113.085 279.017 111.208C274.281 109.288 270.249 106.643 266.921 103.272C263.636 99.8587 261.097 95.8267 259.305 91.176C257.556 86.4827 256.681 81.384 256.681 75.88V20.456H273.897V75.816C273.897 79.3573 274.366 82.5573 275.305 85.416C276.286 88.2747 277.673 90.728 279.465 92.776C281.257 94.7813 283.454 96.3387 286.057 97.448C288.702 98.5573 291.689 99.112 295.017 99.112ZM460.91 20.456V34.6H433.07V113H415.854V34.6H387.886V20.456H460.91ZM588.588 113H575.276C573.783 113 572.545 112.637 571.564 111.912C570.625 111.144 569.943 110.205 569.516 109.096L562.604 90.216H524.268L517.356 109.096C517.015 110.077 516.332 110.973 515.308 111.784C514.327 112.595 513.111 113 511.66 113H498.284L534.636 20.456H552.236L588.588 113ZM528.684 78.056H558.188L546.924 47.272C546.412 45.9067 545.836 44.3067 545.196 42.472C544.599 40.5947 544.001 38.568 543.404 36.392C542.807 38.568 542.209 40.5947 541.612 42.472C541.057 44.3493 540.503 45.992 539.948 47.4L528.684 78.056Z" fill="#292A2F"/>
                    </svg>

                  </div>
                  <p>Welcome back, please login to your account.</p>
                  <form
                    @submit.prevent="attempLogin()"
                  
                    class="mt-3 mt-sm-5"
                  >
                    <div class="row">
                      <div v-if="type == 'email'" class="col-12">
                        <div class="form-group">
                          <label class="control-label">Email*</label>
                          <input
                            type="email"
                            v-model="email"
                            class="form-control"
                            name="email"
                            placeholder="Email"
                            id="email"
                            required
                          />
                        </div>
                      </div>

                      <div v-else class="col-12">
                        <div class="form-group">
                          <label class="control-label">Phone Number*</label>
                          <input
                            type="text"
                            v-model="phoneNumber"
                            class="form-control"
                            name="phoneNumber"
                            id="phoneNumber"
                            placeholder="Phone Number"
                            required
                          />
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="d-block d-sm-flex align-items-center">
                          <div class="form-radio">
                            <label class="form-check-label mr-3" for="gridCheck">Use Email</label>
                            <input
                              class="form-radio-input"
                              v-model="type"
                              type="radio"
                              name="type"
                              value="email"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-6 mb-3">
                        <div class="d-block d-sm-flex align-items-center">
                          <div class="form-radio">
                            <label class="form-check-label mr-3" for="gridCheck">Use Number</label>
                            <input
                              class="form-radio-input"
                              v-model="type"
                              type="radio"
                              name="type"
                              value="number"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="form-group">
                          <label class="control-label">Password*</label>
                          <input
                            type="password"
                            v-model="password"
                            class="form-control"
                            name="password"
                            id="password"
                            placeholder="Password"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="d-block d-sm-flex align-items-center">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              v-model="rememberMe"
                              type="checkbox"
                              id="gridCheck"
                            />
                            <label class="form-check-label" for="gridCheck">Remember Me</label>
                          </div>

                          <a href="javascript:void(0);" class="ml-auto">Forgot Password ?</a>
                        </div>
                      </div>
                      <div class="col-12 mt-3">
                        <button
                          v-if="$store.getters.isLoading"
                          type="submit"
                          class="btn btn-primary text-uppercase"
                          disabled
                        >
                          <div class="spinner-grow text-secondary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </button>
                        <button v-else type="submit" class="btn btn-primary text-uppercase">Sign In</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xxl-9 col-lg-7 bg-gradient o-hidden order-1 order-sm-2">
              <div class="row align-items-center h-100">
                <div class="col-7 mx-auto">
                  <!-- <img class="img-fluid" src="assets/img/bg/login.svg" alt /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end login contant-->
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      phoneNumber: "",
      email: "",
      password: "",
      rememberMe: false,
      type: "email"
    };
  },
  mounted() {},
  methods: {
    getGraph() {
      // this.graph = this.getters.dashboardData;
       fetch(
        this.$store.getters.baseURL + "dashboard/stats",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          }
        }
      )
        .then(res => res.json())
        .then(result => {
 
          if (result.status) {
            this.graph = result.data;
            this.$store.commit("setDashboardData", result.data);
           
            sessionStorage.setItem(
              "dashboardData",
              JSON.stringify(result.data)
            );
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    attempLogin() {
      let raw =
        this.type == "email"
          ? {
              email: this.email,
              password: this.password
            }
          : {
              phone_number: this.phoneNumber,
              password: this.password
            };
       this.$store.commit("setLoading",true);
       
      fetch(this.$store.getters.baseURL + "login", {
        headers: {
          "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify(raw)
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.$store.commit("setPermissions", result.data.permissions);
            this.$store.commit("setRoles", result.data.roles);
            this.$store.commit("setToken", result.data.token);
            this.$store.commit("setUser", result.data.user);
            this.$store.commit("setLogin", true);

           
            console.log("works");
            sessionStorage.setItem("isLoggedIn", true);
            sessionStorage.setItem("token", result.data.token);
            sessionStorage.setItem(
              "permissions",
              JSON.stringify(result.data.permissions)
            );
            sessionStorage.setItem(
              "roles",
              JSON.stringify(result.data.roles)
            );
            sessionStorage.setItem(
              "user",
              JSON.stringify(result.data.user)
            );
            

            
            Swal.fire({
              icon: "success",
              title: result.message,
              text: "Welcome back " + result.data.user.first_name
            });
            this.getGraph();
            window.location = "/";
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
           this.$store.commit("setLoading",false);
        })
        .catch(err => {
          console.log(err);
           this.$store.commit("setLoading",false);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
        });
    }
  }
};
</script>

<style scoped>
</style>